import { render, staticRenderFns } from "./AccountSync.vue?vue&type=template&id=b0e7e1c0"
import script from "./AccountSync.vue?vue&type=script&lang=js"
export * from "./AccountSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports